import { ErrorView } from "@/components/view";

export function ProjectErrorView() {
  return (
    <ErrorView
      title="Project not found"
      description="The project you are looking for does not exist."
      height="60vh"
    />
  );
}
